var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDkSmallIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z",
  fill: "#F9FAFA"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.261 6.957h9.671A8.001 8.001 0 0 0 6.261.19v6.767ZM4.174 6.956V.973A8.005 8.005 0 0 0 .068 6.957h4.106ZM4.174 9.043H.068a8.005 8.005 0 0 0 4.106 5.984V9.043ZM6.26 9.044v6.766a8.001 8.001 0 0 0 9.671-6.766h-9.67Z",
  fill: "#D72A1D"
})));
export { SvgDkSmallIcon as ReactComponent };
export default __webpack_public_path__ + "885b0887c07b1df62ee506408dc5a885.svg";